import styled from 'styled-components';
import { Button } from 'react-bootstrap';

const ConfirmButton = styled(Button)`
  background: #651b93;
  border-color: #651b93;
`;

export default ConfirmButton;
